// extracted by mini-css-extract-plugin
module.exports = {"center":"Modal_center_1ZYW-","loader":"Modal_loader_20wFp","centerTitle":"Modal_centerTitle_heY04","subtitle":"Modal_subtitle_1IJpA","footer":"Modal_footer_novnQ"};